import {TableSettings} from '../../../tableSettings';

export const airImportMawbList:TableSettings = {
  tableVersion: 1017,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const aiQuotationList:TableSettings = {
  tableVersion: 1002,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '260px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'indicator', Header: '#', visible: true, resizable: false, sortable: false, initialWidthPercentage: 3.55, },
    { accessor:'billingCode', Header: 'Billing Code', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 8.43,},
    { accessor:'itemDescription', Header: 'Item Description', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 8.43,},
    { accessor:'cur', Header: 'CUR', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 5.3,},
    { accessor:'Rate', Header: 'Rate', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 11.57,},
    { accessor:'qty', Header: 'Qty', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 16.49,},
    { accessor:'amount', Header: 'Amount', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 16.49,},
    { accessor:'headerAmount', Header: 'USD Amount', visible: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true, initialWidthPercentage: 29.74,},
  ]
};

export const airImportHawbList:TableSettings = {
  tableVersion: 10049,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const hawbAiHblPoBodyLineItems:TableSettings = {
  tableVersion: 1012,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '300px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.59,
    },
    {
      Header: 'PO #',
      accessor: 'poNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.48,
    },
    {
      Header: 'SKU',
      accessor: 'skuNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.93,
    },
    {
      Header: 'HTS Code',
      accessor: 'htsCode',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.62,
    },
    {
      Header: 'C/O',
      accessor: 'coo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.03,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24.14,
    },
    {
      Header: 'Qty',
      accessor: 'shipQty',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'Unit',
      accessor: 'shipUnit',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'Unit Price',
      accessor: 'uPrice',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'KGS(G)',
      accessor: 'kgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'KGS(C)',
      accessor: 'cKgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.72,
    },
  ]
};

export const atmeTable:TableSettings = {
  tableVersion: 1001,
  overflowX: 'hidden',
  overflowY: 'auto',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'HBL or HAWB',
      accessor: 'hbl',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'Customer',
      accessor: 'customer',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'Fax',
      accessor: 'customerFax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Email',
      accessor: 'customerEmail',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Broker',
      accessor: 'broker',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'Fax',
      accessor: 'brokerFax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Email',
      accessor: 'brokerEmail',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
  ]
};